import axios from 'axios';
import { DETALIZATION_PERSONAL_DATA_ACTIONS } from './constants';

// ACTIONS FETCH PERSONAL DATA
export const fetchDetalizationPersonalDataStart = () => ({
  type: DETALIZATION_PERSONAL_DATA_ACTIONS.FETCH_PERSONAL_DATA,
});

export const fetchDetalizationPersonalDataSuccess = (payload) => ({
  type: DETALIZATION_PERSONAL_DATA_ACTIONS.FETCH_PERSONAL_DATA_SUCCESS,
  payload,
});

export const fetchDetalizationPersonalDataError = () => ({
  type: DETALIZATION_PERSONAL_DATA_ACTIONS.FETCH_PERSONAL_DATA_ERROR,
});
// ACTIONS UPDATE PERSONAL DATA
export const updateDetalizationPersonalDataStart = () => ({
  type: DETALIZATION_PERSONAL_DATA_ACTIONS.UPDATE_PERSONAL_DATA,
});

export const updateDetalizationPersonalDataSuccess = (payload) => ({
  type: DETALIZATION_PERSONAL_DATA_ACTIONS.UPDATE_PERSONAL_DATA_SUCCESS,
  payload,
});

export const updateDetalizationPersonalDataError = () => ({
  type: DETALIZATION_PERSONAL_DATA_ACTIONS.UPDATE_PERSONAL_DATA_ERROR,
});

export const setUpdateDetalizationPersonalDataError = (payload) => ({
  type: DETALIZATION_PERSONAL_DATA_ACTIONS.SET_UPDATE_PERSONAL_DATA_ERROR,
  payload,
});
// ACTIONS CONFIRM PERSONAL DATA
export const confirmDetalizationPersonalDataStart = () => ({
  type: DETALIZATION_PERSONAL_DATA_ACTIONS.CONFIRM_PERSONAL_DATA,
});

export const confirmDetalizationPersonalDataSuccess = (payload) => ({
  type: DETALIZATION_PERSONAL_DATA_ACTIONS.CONFIRM_PERSONAL_DATA_SUCCESS,
  payload,
});

export const confirmDetalizationPersonalDataError = (payload) => ({
  type: DETALIZATION_PERSONAL_DATA_ACTIONS.CONFIRM_PERSONAL_DATA_ERROR,
  payload,
});

export const setConfirmDetalizationPersonalDataError = (payload) => ({
  type: DETALIZATION_PERSONAL_DATA_ACTIONS.SET_CONFIRM_PERSONAL_DATA_ERROR,
  payload,
});
// ACTIONS SEND CONFIRMATION CODE
export const sendDetalizationPersonalDataConfirmationCodeStart = () => ({
  type: DETALIZATION_PERSONAL_DATA_ACTIONS.SEND_CONFIRMATION_CODE,
});

export const sendDetalizationPersonalDataConfirmationCodeSuccess = (payload) => ({
  type: DETALIZATION_PERSONAL_DATA_ACTIONS.SEND_CONFIRMATION_CODE_SUCCESS,
  payload,
});

export const sendDetalizationPersonalDataConfirmationCodeError = () => ({
  type: DETALIZATION_PERSONAL_DATA_ACTIONS.SEND_CONFIRMATION_CODE_ERROR,
});

export const setDetalizationConfirmMailData = (payload) => ({
  type: DETALIZATION_PERSONAL_DATA_ACTIONS.SET_CONFIRM_MAIL,
  payload,
});

export const fetchDetalizationConfirmMailData = (payload) => ({
  type: DETALIZATION_PERSONAL_DATA_ACTIONS.FETCH_CONFIRM_MAIL,
  payload,
});

export const setDetalizationConfirmData = () => ({
  type: DETALIZATION_PERSONAL_DATA_ACTIONS.SET_INITIAL_STATE,
});

export const fetchDetalizationPersonalData = () => async (dispatch) => {
  try {
    dispatch(fetchDetalizationPersonalDataStart());

    const { data } = await axios.get('/api/profile/detalization/checkemailnotifications/');

    dispatch(fetchDetalizationPersonalDataSuccess(data));
  } catch (error) {
    dispatch(fetchDetalizationPersonalDataError());
  }
};

export const updateDetalizationPersonalData = (data) => async (dispatch) => {
  dispatch(updateDetalizationPersonalDataStart());

  try {
    await axios.post('/api/profile/settings/notifications/notificationpoint/', data);
    await axios.post('/api/profile/settings/notifications/sendnotificationpointconfirmationcode/', { type: data.type });

    dispatch(updateDetalizationPersonalDataSuccess(data.value));
  } catch (error) {
    dispatch(updateDetalizationPersonalDataError());
  }
};

export function confirmDetalizationPersonalData(data) {
  return async (dispatch) => {
    dispatch(confirmDetalizationPersonalDataStart());

    try {
      await axios.post('/api/profile/settings/notifications/confirmnotificationpointcode/', data);
      dispatch(confirmDetalizationPersonalDataSuccess(true));
    } catch (error) {
      const inCorrectConfirmationCode = error?.response?.data?.code === 'INCORRECT_CONFIRMATION_CODE';

      dispatch(confirmDetalizationPersonalDataError(inCorrectConfirmationCode));
    }
  };
}

export const sendDetalizationPersonalDataConfirmationCode = (type) => async (dispatch) => {
  dispatch(sendDetalizationPersonalDataConfirmationCodeStart());

  try {
    await axios.post('/api/profile/settings/notifications/sendnotificationpointconfirmationcode/', { type });

    dispatch(sendDetalizationPersonalDataConfirmationCodeSuccess());
  } catch (error) {
    dispatch(sendDetalizationPersonalDataConfirmationCodeError());
  }
};
